import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'src/components/design-system/Button';
import GridCellBase from 'src/components/GridCellBase';
import { WorkAreaContext } from 'src/sections/work_area/WorkAreaContext';
import { CompanySearchResult } from 'src/types/work_area';
import { stopPropagation } from 'src/utils';
import { useContextSelector } from 'use-context-selector';

type SearchResultsActionCellProps = GridCellProps & {
  onCloseModal?: () => void;
};

const SearchResultsActionCell = (props: SearchResultsActionCellProps) => {
  const { t } = useTranslation();
  const getImpersonate = useContextSelector(WorkAreaContext, (ctx) => ctx.getImpersonate);
  const { onCloseModal, ...gridProps } = props;
  const row = gridProps.dataItem as CompanySearchResult;
  const { clientId, parentCompanyId } = row;
  const { canImpersonate, isImpersonatedUser, handleImpersonate } = useMemo(
    () => getImpersonate(clientId, parentCompanyId),
    [getImpersonate, clientId, parentCompanyId]
  );

  const handleClick = useCallback(
    (e: MouseEvent) => {
      stopPropagation(e);
      onCloseModal?.();
      handleImpersonate();
    },
    [handleImpersonate, onCloseModal]
  );

  return (
    <GridCellBase {...gridProps} className="!p-0" rowSelectionEnabled={false}>
      <div className="flex items-center justify-center min-w-[100px] px-2">
        <Button
          type="button"
          color="info"
          disabled={!canImpersonate}
          onClick={handleClick}
          size="sm"
          className="w-fit text-[12px]"
        >
          {t(isImpersonatedUser ? 'impersonated' : 'impersonate')}
        </Button>
      </div>
    </GridCellBase>
  );
};

export default SearchResultsActionCell;
